import { type CompareContrastData } from "@/types/models/Exportables.interface";

export const updateTopic = (
  side:
    | "left-topic"
    | "right-topic"
    | "center-section"
    | "left-section"
    | "right-section",
  value: string,
  onChange: ((data: CompareContrastData) => void) | undefined,
  formData: CompareContrastData | null | undefined,
) => {
  if (!onChange) return;

  const updater = (prev: CompareContrastData): CompareContrastData => {
    const updatedPairs = prev?.topic_pairs ? [...prev.topic_pairs] : [[]];

    if (!updatedPairs[0]) updatedPairs[0] = [];

    if (side === "left-topic") {
      updatedPairs[0][0] = value;
    } else if (side === "right-topic") {
      updatedPairs[0][1] = value;
    } else if (side === "left-section") {
      updatedPairs[0][2] = value;
    } else if (side === "right-section") {
      updatedPairs[0][3] = value;
    } else if (side === "center-section") {
      updatedPairs[0][4] = value;
    }

    return { ...prev, topic_pairs: updatedPairs };
  };

  onChange(updater(formData ?? {}));
};
